import { render, staticRenderFns } from "./DetailsAdd.vue?vue&type=template&id=1b5921c4&"
import script from "./DetailsAdd.vue?vue&type=script&lang=js&"
export * from "./DetailsAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports